function validationError(message) {
  var line = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var column = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return {
    valid: false,
    message: message,
    line: line,
    column: column
  };
}
function validateJavaScript(source, acorn) {
  if (!(acorn !== null && acorn !== void 0 && acorn.parse)) {
    return validationError('JavaScript parser failed to load');
  }
  try {
    acorn.parse(source, {
      ecmaVersion: 'latest',
      sourceType: 'script',
      allowHashBang: true,
      allowReturnOutsideFunction: true,
      allowAwaitOutsideFunction: true
    });
    return {
      valid: true,
      message: 'Valid JavaScript'
    };
  } catch (err) {
    var _err$loc$line, _err$loc, _err$loc$column, _err$loc2;
    return validationError(err.message, (_err$loc$line = (_err$loc = err.loc) === null || _err$loc === void 0 ? void 0 : _err$loc.line) !== null && _err$loc$line !== void 0 ? _err$loc$line : null, ((_err$loc$column = (_err$loc2 = err.loc) === null || _err$loc2 === void 0 ? void 0 : _err$loc2.column) !== null && _err$loc$column !== void 0 ? _err$loc$column : -1) + 1);
  }
}
function validateCssBalance(source) {
  var pairs = {
    '{': '}',
    '[': ']',
    '(': ')'
  };
  var openers = new Set(Object.keys(pairs));
  var closers = new Set(Object.values(pairs));
  var stack = [];
  var quote = '';
  var escaped = false;
  var inComment = false;
  var line = 1;
  var column = 0;
  for (var i = 0; i < source.length; i++) {
    var _char = source[i];
    var next = source[i + 1];
    column += 1;
    if (_char === '\n') {
      line += 1;
      column = 0;
    }
    if (inComment) {
      if (_char === '*' && next === '/') {
        inComment = false;
        i += 1;
        column += 1;
      }
      continue;
    }
    if (quote) {
      if (escaped) {
        escaped = false;
      } else if (_char === '\\') {
        escaped = true;
      } else if (_char === quote) {
        quote = '';
      }
      continue;
    }
    if (_char === '/' && next === '*') {
      inComment = true;
      i += 1;
      column += 1;
      continue;
    }
    if (_char === '"' || _char === "'") {
      quote = _char;
      continue;
    }
    if (openers.has(_char)) {
      stack.push({
        "char": _char,
        line: line,
        column: column
      });
      continue;
    }
    if (closers.has(_char)) {
      var opener = stack.pop();
      if (!opener || pairs[opener["char"]] !== _char) {
        return validationError("Unexpected \"".concat(_char, "\""), line, column);
      }
    }
  }
  if (inComment) {
    return validationError('Unclosed comment', line, column);
  }
  if (quote) {
    return validationError('Unclosed string', line, column);
  }
  if (stack.length) {
    var _opener = stack.at(-1);
    return validationError("Unclosed \"".concat(_opener["char"], "\""), _opener.line, _opener.column);
  }
  return null;
}
function validateCss(source, csstree) {
  if (!(csstree !== null && csstree !== void 0 && csstree.parse) || !(csstree !== null && csstree !== void 0 && csstree.walk) || !(csstree !== null && csstree !== void 0 && csstree.generate)) {
    return validationError('CSS parser failed to load');
  }
  var balanceError = validateCssBalance(source);
  if (balanceError) {
    return balanceError;
  }
  var errors = [];
  try {
    var ast = csstree.parse(source, {
      positions: true,
      onParseError: function onParseError(err) {
        return errors.push(err);
      }
    });
    if (errors.length) {
      var _ref, _err$loc$start$line, _err$loc3, _ref2, _err$loc$start$column, _err$loc4;
      var err = errors[0];
      return validationError(err.message, (_ref = (_err$loc$start$line = (_err$loc3 = err.loc) === null || _err$loc3 === void 0 || (_err$loc3 = _err$loc3.start) === null || _err$loc3 === void 0 ? void 0 : _err$loc3.line) !== null && _err$loc$start$line !== void 0 ? _err$loc$start$line : err.line) !== null && _ref !== void 0 ? _ref : null, (_ref2 = (_err$loc$start$column = (_err$loc4 = err.loc) === null || _err$loc4 === void 0 || (_err$loc4 = _err$loc4.start) === null || _err$loc4 === void 0 ? void 0 : _err$loc4.column) !== null && _err$loc$start$column !== void 0 ? _err$loc$start$column : err.column) !== null && _ref2 !== void 0 ? _ref2 : null);
    }
    var emptyDeclaration = null;
    csstree.walk(ast, function (node) {
      if (!emptyDeclaration && node.type === 'Declaration' && csstree.generate(node.value).trim() === '') {
        emptyDeclaration = node;
      }
    });
    if (emptyDeclaration) {
      var _emptyDeclaration$loc, _emptyDeclaration$loc2, _emptyDeclaration$loc3, _emptyDeclaration$loc4;
      return validationError("Missing value for \"".concat(emptyDeclaration.property, "\""), (_emptyDeclaration$loc = (_emptyDeclaration$loc2 = emptyDeclaration.loc) === null || _emptyDeclaration$loc2 === void 0 || (_emptyDeclaration$loc2 = _emptyDeclaration$loc2.start) === null || _emptyDeclaration$loc2 === void 0 ? void 0 : _emptyDeclaration$loc2.line) !== null && _emptyDeclaration$loc !== void 0 ? _emptyDeclaration$loc : null, (_emptyDeclaration$loc3 = (_emptyDeclaration$loc4 = emptyDeclaration.loc) === null || _emptyDeclaration$loc4 === void 0 || (_emptyDeclaration$loc4 = _emptyDeclaration$loc4.start) === null || _emptyDeclaration$loc4 === void 0 ? void 0 : _emptyDeclaration$loc4.column) !== null && _emptyDeclaration$loc3 !== void 0 ? _emptyDeclaration$loc3 : null);
    }
    return {
      valid: true,
      message: 'Valid CSS'
    };
  } catch (err) {
    var _ref3, _err$loc$start$line2, _err$loc5, _ref4, _err$loc$start$column2, _err$loc6;
    return validationError(err.message, (_ref3 = (_err$loc$start$line2 = (_err$loc5 = err.loc) === null || _err$loc5 === void 0 || (_err$loc5 = _err$loc5.start) === null || _err$loc5 === void 0 ? void 0 : _err$loc5.line) !== null && _err$loc$start$line2 !== void 0 ? _err$loc$start$line2 : err.line) !== null && _ref3 !== void 0 ? _ref3 : null, (_ref4 = (_err$loc$start$column2 = (_err$loc6 = err.loc) === null || _err$loc6 === void 0 || (_err$loc6 = _err$loc6.start) === null || _err$loc6 === void 0 ? void 0 : _err$loc6.column) !== null && _err$loc$start$column2 !== void 0 ? _err$loc$start$column2 : err.column) !== null && _ref4 !== void 0 ? _ref4 : null);
  }
}
function validateSource(type, source) {
  var parsers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : globalThis;
  if (typeof source !== 'string' || source.trim() === '') {
    return validationError('Source is empty', 1, 1);
  }
  return type === 'css' ? validateCss(source, parsers.csstree) : validateJavaScript(source, parsers.acorn);
}
module.exports = {
  validateSource: validateSource
};